import { ActionOptionsArgs, BaseAction, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { BaseObjectFilters } from '../../store/bootstrap';
import { JobStatus } from './job-status.model';
import { Action } from '@ngrx/store';

export const ENTITY = 'jobStatus';
export const REHYDRATE = '[JobStatus] Rehydrate';
export const REMOVE = '[JobStatus] Remove';
export const SUBMIT = '[JobStatus] Submit';
export const SET_FILTER = '[JobStatus] Set Filter';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: JobStatus, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly entity = ENTITY;
    readonly type = REHYDRATE;

    constructor(public payload: Array<JobStatus>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: JobStatus, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class SetFilterAction extends BaseAction {
    readonly type = SET_FILTER;
    readonly entity = ENTITY;

    constructor(public payload: BaseObjectFilters, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction
    | SetFilterAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-status/job-status.actions.ts